import React, { useState } from "react";
import { Button } from "@amzn/awsui-components-react";
import '../styles.scss';

const ShareLinkButton = ({ data }) => {
  const [linkCopied, setLinkCopied] = useState(false);

  const handleShareLink = () => {
    const hostname = window.location.hostname;
    const isBeta = hostname.includes('beta') || hostname === 'localhost';
    const baseUrl = isBeta
      ? 'https://beta.bi-central.accounting.amazon.dev'
      : 'https://bi-central.accounting.amazon.dev';
    const shareUrl = `${baseUrl}/firstpass?resultId=${data?.request_id}`;
    navigator.clipboard.writeText(shareUrl).then(() => {
      setLinkCopied(true);
      setTimeout(() => setLinkCopied(false), 2000);
    });
  }

  return (
    <div className="share-link-button-wrapper">
      {linkCopied && (
        <div className="share-link-tooltip">
          Copied!
        </div>
      )}
      <Button
        iconName="share"
        variant="icon"
        onClick={handleShareLink}
      />
    </div>
  );
};

export default ShareLinkButton;
